<script setup lang="ts">
import { toRef } from 'vue';
import { IFormItem, ICountryItem } from '../utils/interfaces';
import { usePrivacySelection } from '../hooks/usePrivacySelection';
import { useClearCss } from '../hooks/useClearCss';
import ContactFormPrivacyCTA from './ContactFormPrivacyCTA.vue';

interface ContactFormPrivacyInfoProps {
  isActive: boolean;
  formItem: IFormItem;
  countryItem: ICountryItem | null;
}

const props = defineProps<ContactFormPrivacyInfoProps>();
const countryItemRef = toRef(props, 'countryItem');
const { clearCss } = useClearCss();

const { 
      currentRole,
      isRoles,
      getRoleOptions,
      showSecondInfo,
      getSecondInfo,
      showCTA,
      getCTAInfo
      } = usePrivacySelection(props.formItem, countryItemRef);
</script>

<template>
  <div
    v-show="isActive"
    class="privacy-info-container"
  >
    <div
      v-if="countryItem?.countryInformationShowInformation"
      v-html="clearCss(countryItem?.countryInformation.html)"
      class="information-panel"
      data-pw-form="privacy-country-information"
    />
    <div
      v-show="isRoles"
      class="role-container"
     >
      <FormKit
          type="select"
          name="roles"
          v-model="currentRole"
          :label="formItem.roleQuestion"
          :placeholder="formItem.rolePlaceholder"
          :options="getRoleOptions"
          validation="required"
          :validation-messages="{ required: formItem.roleErrorMessage }"
          data-pw-form="privacy-roles"
        />
    </div>
    <div
      v-show="showSecondInfo"
      v-html="clearCss(getSecondInfo)"
      class="information-panel"
      data-pw-form="privacy-second-information"
    />
    <ContactFormPrivacyCTA
      v-show="showCTA"
      :href="getCTAInfo.urlChoice"
      :linkMessage="getCTAInfo.ctaChoice"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "../../site/variables";

.information-panel {
  :deep(a) {
    color: variables.$color-black;
    text-decoration: underline;
  }

  :deep(ul),
  :deep(ol) {
    list-style: initial;
    list-style-position: inside;
  }
}
</style>

